import {put, takeLatest, call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    BULKUPDATE_VENUES,
    BULKUPDATE_VENUES_SUCCESS,
    BULKUPDATE_VENUES_ERROR,
}
    from "../../actions/venue";

function* bulkUpdateVenuesSaga(action) {
    try {
       const data  = yield call(venueService.BulkUpdateVenues,action.payload)
        
       yield put({
        type: BULKUPDATE_VENUES_SUCCESS,
        payload: data
    });


    } catch (error) {
        yield put({
            type: BULKUPDATE_VENUES_ERROR,error: error.data
        });
    }
}


export function* bulkUpdateVenuesSagaWatcher() {
    yield takeLatest(BULKUPDATE_VENUES, bulkUpdateVenuesSaga);
}